import { createFrontendModule } from "@backstage/frontend-plugin-api";
import {
    createFormField,
    FormFieldBlueprint,
} from "@backstage/plugin-scaffolder-react/alpha";

import { ProductNameField } from "./components";

const ProductNameFieldExtension = FormFieldBlueprint.make({
    name: "product-name-field",
    params: {
        field: async () =>
            createFormField({
                name: "ProductNameField",
                component: ProductNameField,
            }),
    },
});

const scaffolderModuleProductNameField = createFrontendModule({
    pluginId: "scaffolder",
    extensions: [ProductNameFieldExtension],
});

export default scaffolderModuleProductNameField;
